module.exports = __webpack_public_path__ + "static/media/wreath.86b04faf.svg";